import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthProvider } from './context/auth';
import AuthRoute from './util/AuthRoute';
import Home from './component/Pages/Home';
import Navbar from './component/Pages/Navbar';
import Signup from './component/Pages/Signup';
import Contact from './component/Pages/Contact';
import About from './component/Pages/About';
import Login from './component/Pages/Login';
import Wallpaper from './component/Pages/Wallpaper'
import UpdateWallpaper from './component/Pages/UpdateWallpaper'
import Footer from "./component/Pages/Footer";
import NoInternet from "./component/Pages/NoInternet";



function App() {

  return (
   <div className="App">
    <NoInternet>
    <AuthProvider>
   <BrowserRouter>
   <Navbar/>
    <Switch>
    <Route exact path="/" component={Home}/>
     
     <AuthRoute path="/login" component={Login}/>
     <AuthRoute path="/signup" component={Signup}/>
     <Route exact path="/contact" component={Contact}/>
     <Route exact path="/about" component={About}/>
     <Route exact path="/wallpaper/:id" component={Wallpaper}/>
     <Route exact path="/Update/:id" component={UpdateWallpaper}/>
    </Switch>
    </BrowserRouter>
    </AuthProvider>
    <Footer/>
    </NoInternet>
   </div>
  );
}

export default App;